<template>
  <div class="agreement-page">
    <div class="agreement-header">
      <h1>用户协议</h1>
    </div>
    
    <div class="agreement-content">
      <section class="agreement-section">
        <h2>主体信息</h2>
        <p>本应用由芝韵文化艺术（广州）有限公司（以下简称"本应用开发者"）运营和研发。</p>
        <p>公司名称：芝韵文化艺术（广州）有限公司</p>
        <p>注册地址：广州市天河区</p>
        <p>联系方式：</p>
        <ul>
          <li>邮箱：fg2222222@qq.com</li>
          <li>电话：13717478432</li>
        </ul>
      </section>

      <section class="agreement-section">
        <h2>1. 协议的接受与修改</h2>
        <p>欢迎您使用幸福输入（以下简称"本应用"）。本用户协议（以下简称"本协议"）是您与本应用开发者之间关于使用本应用服务所订立的协议。</p>
        <p>请您仔细阅读本协议的全部内容（特别是以粗体标注的内容），如您不同意本协议的任意内容，请勿注册或使用本应用。当您点击"同意"按钮或以其他方式选择接受本协议，或者您下载、安装、使用本应用时，即表示您已充分阅读、理解并接受本协议的全部内容，并与本应用开发者达成协议。</p>
        <p><strong>重要说明：本应用承诺在您明确同意《用户协议》和《隐私政策》之前，不会收集任何个人信息或启用任何需要权限的功能。所有个人信息收集行为（包括第三方SDK的数据收集）均在您同意后进行。</strong></p>
        <p>本应用开发者有权在必要时修改本协议条款。您可以在本应用的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本应用，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本应用。</p>
      </section>
      
      <section class="agreement-section">
        <h2>2. 账号注册与安全</h2>
        <p>2.1 您在使用本应用前需要注册一个账号。您承诺提供真实、准确、完整、有效的个人资料，如因资料不实而引起的问题，由您自行承担相应后果。</p>
        <p>2.2 您应对您的账号安全负全部责任，且应对您在该账号下的所有行为负责。如发现任何未经授权使用您账号的情况，您应立即通知我们。</p>
        <p>2.3 未经本应用开发者同意，您不得将账号转让或者出借给他人使用。</p>
      </section>
      
      <section class="agreement-section">
        <h2>3. 用户行为规范</h2>
        <p>3.1 您在使用本应用的过程中，必须遵守中华人民共和国相关法律法规的规定，不得利用本应用从事违法违规行为，包括但不限于以下行为：</p>
        <ul>
          <li>发布、传送、传播、储存违反国家法律法规禁止的内容</li>
          <li>发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容</li>
          <li>使用本应用进行任何可能对互联网正常运转造成不利影响的行为</li>
          <li>使用本应用进行任何不利于本应用的行为</li>
        </ul>
        <p>3.2 如果您违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求本应用开发者给予协助。造成损害的，您应依法予以赔偿，本应用开发者不承担任何责任。</p>
      </section>
      
      <section class="agreement-section">
        <h2>4. 知识产权</h2>
        <p>4.1 本应用开发者是本应用的知识产权权利人。本应用的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本应用相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，本应用开发者享有上述知识产权。</p>
        <p>4.2 未经本应用开发者或相关权利人书面同意，您不得以任何方式获取或使用上述资料。</p>
      </section>
      
      <section class="agreement-section">
        <h2>5. 隐私保护与信息收集</h2>
        <p>5.1 <strong>信息收集原则：</strong>本应用严格遵循合法、正当、必要的原则收集用户个人信息，所有信息收集均在您明确同意后进行。</p>
        <p>5.2 <strong>收集范围说明：</strong></p>
        <ul>
          <li><strong>设备信息：</strong>包括设备MAC地址（用于设备唯一标识）、设备IMEI（用于防止账号异常）、设备型号和系统版本（用于功能适配）</li>
          <li><strong>软件安装列表：</strong>用于为您推荐相关输入法功能，提供更好的用户体验</li>
          <li><strong>存储访问：</strong>仅访问应用专用目录，用于保存配置文件、用户词库和皮肤资源，不读取您的其他个人文件</li>
          <li><strong>通讯录和短信：</strong>仅在您明确授权时收集，分别用于联系人姓名快速输入和验证码自动填充功能</li>
        </ul>
        <p>5.3 <strong>第三方SDK：</strong>本应用集成了以下第三方SDK，可能收集相关信息：</p>
        <ul>
          <li><strong>APP支付客户端SDK（支付宝）：</strong>收集设备信息、网络信息、应用信息，用于提供支付服务</li>
          <li><strong>对象存储OSS Android SDK（阿里云）：</strong>收集设备信息、网络信息、应用信息，用于提供云端存储服务</li>
          <li><strong>微信OpenSDK Android（腾讯）：</strong>收集设备信息、网络信息、应用信息，用于提供微信登录和分享功能</li>
        </ul>
        <p>所有第三方SDK的数据收集均在您同意隐私政策后进行，具体信息请参阅《隐私政策》中的详细说明。</p>
        <p>5.4 <strong>用户权利：</strong>您有权随时撤销权限授权、访问、更正、删除您的个人信息，或注销您的账号。</p>
        <p>5.5 详细的隐私保护措施和信息处理方式请参阅我们的《隐私政策》。</p>
      </section>
      
      <section class="agreement-section">
        <h2>6. 免责声明</h2>
        <p>6.1 您理解并同意，本应用开发者不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据方面的损失或其他无形损失的损害赔偿：</p>
        <ul>
          <li>本应用的使用或无法使用</li>
          <li>通过本应用购买或获取的任何产品、服务、信息或交易，或您的信息或交易的替代品获取成本</li>
          <li>您的传输或数据遭到未获授权的存取或变更</li>
          <li>任何第三方在本应用中所作之声明或行为</li>
          <li>其他与本应用相关的事宜</li>
        </ul>
        <p>6.2 您理解并同意，如因您违反有关法律或者本协议之规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您应当赔偿本应用开发者与合作伙伴、关联公司，并使之免受损害。</p>
      </section>
      
      <section class="agreement-section">
        <h2>7. 协议终止</h2>
        <p>7.1 本协议自您接受之日起生效，在您使用本应用的过程中持续有效。</p>
        <p>7.2 本应用开发者有权在必要时终止向您提供服务，终止理由包括但不限于：</p>
        <ul>
          <li>您违反本协议的约定</li>
          <li>本应用升级、维护或其他原因需要暂停或终止服务</li>
          <li>不可抗力导致本应用无法继续提供服务</li>
        </ul>
        <p>7.3 协议终止后，您应停止使用本应用，本应用开发者不再对您承担任何义务，但本协议另有约定的除外。</p>
      </section>
      
      <section class="agreement-section">
        <h2>8. 法律适用与争议解决</h2>
        <p>8.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
        <p>8.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向本应用开发者所在地有管辖权的人民法院提起诉讼。</p>
      </section>
      
      <section class="agreement-section">
        <h2>9. 其他规定</h2>
        <p>9.1 本协议任何条款被视为无效，都不影响其他条款的效力。</p>
        <p>9.2 本应用开发者有权随时更新本协议，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。您可以在本应用中查阅最新版协议条款。</p>
        <p>9.3 本协议最终解释权归本应用开发者所有。</p>
      </section>
      
      <div class="agreement-footer">
        <p>最后更新日期：2024年12月21日</p>
        <p><strong>重要更新：</strong>根据工信部SDK合规要求，已更新第三方SDK信息披露内容</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreementPage',
  metaInfo: {
    title: '用户协议 - 幸福输入'
  }
}
</script>

<style scoped>
.agreement-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Poppins', 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.agreement-header {
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.back-link {
  position: absolute;
  left: 0;
  top: 10px;
  color: #6C63FF;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.back-icon {
  margin-right: 5px;
  font-size: 18px;
}

.agreement-header h1 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #333;
}

.agreement-content {
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.agreement-section {
  margin-bottom: 30px;
}

.agreement-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.agreement-section p {
  margin-bottom: 15px;
  font-size: 15px;
}

.agreement-section ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.agreement-section li {
  margin-bottom: 8px;
  font-size: 15px;
}

.agreement-footer {
  text-align: right;
  margin-top: 40px;
  color: #888;
  font-size: 14px;
}

@media (max-width: 768px) {
  .agreement-page {
    padding: 20px 15px;
  }
  
  .agreement-content {
    padding: 20px;
  }
  
  .agreement-header h1 {
    font-size: 24px;
  }
  
  .agreement-section h2 {
    font-size: 18px;
  }
  
  .agreement-section p,
  .agreement-section li {
    font-size: 14px;
  }
}
</style> 